import React from 'react';
import ReactDOM from 'react-dom/client';
import { useState, useEffect } from 'react';
import './index.css';
import i18n from './i18n'; // <- important: initialize i18n BEFORE App
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { ScaleLoader } from 'react-spinners';

const root = ReactDOM.createRoot(document.getElementById('root'));

function RootApp() {
  const [lang, setLang] = useState(localStorage.getItem('appLanguage') || 'en');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleLangChange = (lang) => {
      setLoading(true);
      setLang(lang);
      const timer = setTimeout(() => setLoading(false), 2000);
      return () => clearTimeout(timer);
    };

    i18n.on('languageChanged', handleLangChange);

    return () => {
      i18n.off('languageChanged', handleLangChange);
    };
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <ScaleLoader color="#7a2cc7" loading={true} />
      </div>
    );
  }

  return <App />;
}

root.render(
  <React.StrictMode>
    <AuthProvider>
      <RootApp />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
